import React, { useState } from "react";
import { Collapse, Table, Button, Select, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const { Panel } = Collapse;
const { Option } = Select;
const AppointmentManager = () => {
  const [
    upcomingAppointmentManagementData,
    setUpcomingAppointmentManagementData,
  ] = useState([
    {
      key: 1,
      servicename: "X-Ray",
      patientname: "Testing",
      patientaddress: "Testing data",
      price: 400,
      timing: "2PM-4PM",
    },
    {
      key: 2,
      servicename: "Dental X-Ray",
      patientname: "Testing",
      patientaddress: "Testing data",
      price: 400,
      timing: "2PM-4PM",
    },
  ]);

  const [appointmentManagementData, setappointmentManagementData] = useState([
    {
      key: 1,
      servicename: "X-Ray",
      patientname: "Testing",
      patientaddress: "Testing data",
      price: 400,
      timing: "2PM-4PM",
    },
    {
      key: 2,
      servicename: "Dental X-Ray",
      patientname: "Testing",
      patientaddress: "Testing data",
      price: 400,
      timing: "2PM-4PM",
    },
    {
      key: 3,
      servicename: "Mommograghy",
      patientname: "Testing",
      patientaddress: "Testing data",
      price: 400,
      timing: "2PM-4PM",
    },
    {
      key: 4,
      servicename: "Bone Density Scan",
      patientname: "Testing",
      patientaddress: "Testing data",
      price: 400,
      timing: "2PM-4PM",
    },
    {
      key: 5,
      servicename: "Ultrasound",
      patientname: "Testing",
      patientaddress: "Testing data",
      price: 400,
      timing: "2PM-4PM",
    },
    {
      key: 6,
      servicename: "CT scan",
      patientname: "Testing",
      patientaddress: "Testing data",
      price: 400,
      timing: "2PM-4PM",
    },
    {
      key: 7,
      servicename: "MRI",
      patientname: "Testing",
      patientaddress: "Testing data",
      price: 400,
      timing: "2PM-4PM",
    },
    {
      key: 8,
      servicename: "PET Scab",
      patientname: "Testing",
      patientaddress: "Testing data",
      price: 400,
      timing: "2PM-4PM",
    },
    {
      key: 9,
      servicename: "Fluoroscopy",
      patientname: "Testing",
      patientaddress: "Testing data",
      price: 400,
      timing: "2PM-4PM",
    },
    {
      key: 10,
      servicename: "Angiography",
      patientname: "Testing",
      patientaddress: "Testing data",
      price: 400,
      timing: "2PM-4PM",
    },
  ]);

  const upcomingAppointmentManagementCol = [
    {
      title: "Service Name",
      dataIndex: "servicename",
      key: "servicename",
    },
    {
      title: "Patient Name",
      dataIndex: "patientname",
      key: "patientname",
    },
    {
      title: "Patient Address",
      dataIndex: "patientaddress",
      key: "patientaddress",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Timing",
      key: "timing",
      dataIndex: "timing",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Button type="primary">Accept</Button>
          <Button type="primary" danger>
            Reject
          </Button>
        </div>
      ),
    },
  ];
  const appointmentManagementCol = [
    {
      title: "Service Name",
      dataIndex: "servicename",
      key: "servicename",
    },
    {
      title: "Patient Name",
      dataIndex: "patientname",
      key: "patientname",
    },
    {
      title: "Patient Address",
      dataIndex: "patientaddress",
      key: "patientaddress",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Timing",
      key: "timing",
      dataIndex: "timing",
    },
    {
      title: "File Upload",
      key: "upload",
      render: (_, record) => (
        <Upload
          multiple={false} // Set to true if multiple file uploads are allowed
          beforeUpload={(file) => {
            console.log("Uploading file for:", record.name);
            console.log("File details:", file);
            // Add file handling logic here (e.g., send to backend)
            return false; // Prevent automatic upload
          }}
        >
          <Button icon={<UploadOutlined />}>Upload</Button>
        </Upload>
      ),
    },
  ];
  return (
    <div className="appointment-container">
      <Table
        title={() => <h2 style={{ margin: 0 }}>Upcoming Appointments</h2>}
        columns={upcomingAppointmentManagementCol}
        dataSource={upcomingAppointmentManagementData}
        pagination={{
          pageSize: 5, // Show 5 rows per page
        }}
      />
      <Table
        title={() => <h2 style={{ margin: 0 }}>Accepted Appointments</h2>}
        columns={appointmentManagementCol}
        dataSource={appointmentManagementData}
        pagination={{
          pageSize: 5, // Show 5 rows per page
        }}
      />
    </div>
  );
};

export default AppointmentManager;
